const cohortQueryActions = {
  ADD_COHORT_QUERY: 'ADD_COHORT_QUERY',
  CLONE_COHORT_QUERY: 'CLONE_COHORT_QUERY',
  REMOVE_COHORT_QUERY: 'REMOVE_COHORT_QUERY',
  SHOW_RENAME_QUERY: 'SHOW_RENAME_QUERY',
  HIDE_RENAME_QUERY: 'HIDE_RENAME_QUERY',
  UPDATE_ACTIVE_QUERY_PROPERTIES: 'UPDATE_ACTIVE_QUERY_PROPERTIES',
};

export default cohortQueryActions;
